import React from "react";

import {rpAppLink} from "@pg-mono/rp-routes";

import {Breadcrumbs} from "../../app/components/breadcrumbs/Breadcrumbs";
import {BreadcrumbsItem} from "../../app/components/breadcrumbs/BreadcrumbsItem";
import {useVendorBreadcrumbs} from "../hooks/use_vendor_breadcrumbs";

export const VendorBreadcrumbs = React.memo(() => {
    const breadcrumbs = useVendorBreadcrumbs();

    return (
        <Breadcrumbs homePageUrl={rpAppLink.base()}>
            {breadcrumbs.map((breadcrumb, index) => (
                <BreadcrumbsItem {...breadcrumb} key={breadcrumb.name} isLinkingToCurrentLocation={breadcrumbs.length - 1 === index} />
            ))}
        </Breadcrumbs>
    );
});
import React from "react";

import {rpAppLink} from "@pg-mono/rp-routes";

import {Breadcrumbs} from "../../app/components/breadcrumbs/Breadcrumbs";
import {BreadcrumbsItem} from "../../app/components/breadcrumbs/BreadcrumbsItem";
import {useVendorBreadcrumbs} from "../hooks/use_vendor_breadcrumbs";

export const VendorBreadcrumbs = React.memo(() => {
    const breadcrumbs = useVendorBreadcrumbs();

    return (
        <Breadcrumbs homePageUrl={rpAppLink.base()}>
            {breadcrumbs.map((breadcrumb, index) => (
                <BreadcrumbsItem {...breadcrumb} key={breadcrumb.name} isLinkingToCurrentLocation={breadcrumbs.length - 1 === index} />
            ))}
        </Breadcrumbs>
    );
});
